import React, {useEffect} from "react";
import { useField } from "formik";
import { InputHelper, InputHelperOptionalParameters } from "./InputHelper";
import {Text} from "rebass";
import styled from "styled-components";

export const SelectInput: React.FC<{
  name: string;
  options: string[];
  selectedIndex?: number;
  allowEmpty?: boolean;
  helperParameters?: InputHelperOptionalParameters;
  onChange?: (string) => void;
}> = ({ name, options, selectedIndex, allowEmpty, helperParameters= {label: name}, onChange}) => {
  const validate = (value) => {
    if (value === "" && !allowEmpty) {
      return "Select a value";
    }
  };


  const [field, meta, helpers] = useField({ name, validate });


  return (
    <InputHelper meta={meta} helpers={helpers} {...helperParameters}>
      <Selector options={options} defaultIndex={selectedIndex} allowEmpty={allowEmpty}
                onChange={(option) => {
                  helpers.setValue(option)
                  if(onChange)
                    onChange(option);
                }}/>
    </InputHelper>
  )

};

export const Selector: React.FC<{
  options: string[];
  defaultIndex?: number;
  allowEmpty?: boolean;
  onChange?: (string) => void;
}> = ({options, defaultIndex, allowEmpty=false, onChange}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const getDefaultOption = () => defaultIndex !== undefined? options[defaultIndex]: allowEmpty? "":options[0]
  const [selectedOption, setSelectedOption] = React.useState<string>(getDefaultOption())

  useEffect( () => {
    if (onChange) onChange(selectedOption)
  }, [selectedOption])

  useEffect( () => {
    setSelectedOption(getDefaultOption())
  }, [defaultIndex, options])

  let width = 11 * Math.max(5, ...options.map((option: string) => option.length)) + 32 + "px"
  if(allowEmpty)
   width = width+20;

  return (
    <>
      <StyledSelectOpener onClick={() => setIsOpen(!isOpen)} width={width}>
        <Text> {selectedOption || "Please Select"} </Text>
        <img className="svg_button" src="/ui/expand.svg" alt="expand"
             style={{
               width: "16px",
               marginLeft: "8px",
               marginRight: "8px",
               transform: "scale(" + (isOpen? -1:1) + ")"
             }}
        />
      </StyledSelectOpener>

      {isOpen?
        <StyledSelectionTable width={width}>
          <tbody>
          {allowEmpty ?
            <Option storedValue="Please Select" index={0} onClick={() => {setSelectedOption(""); setIsOpen(false)}}/>
            :undefined}

          {options.map((option, index) => (
            <Option key={option} storedValue={option} index={index + (allowEmpty? 1:0)} onClick={() => {setSelectedOption(option); setIsOpen(false)}}/>
          ))}
          </tbody>
        </StyledSelectionTable>: undefined}
    </>
  );

}

const Option: React.FC<{
  index: number;
  storedValue: string;
  onClick: () => void;
}> = ({index, storedValue, onClick}) => {
  const defaultBackground = index%2 === 0? "#F4F9FF":"white"

  const [backgroundColor, setBackgroundColor] = React.useState<string>(defaultBackground)

  return (
    <tr>
      <StyledOption
        onClick={() => onClick()}
        onMouseEnter={() => setBackgroundColor("#d6f0ff")}
        onMouseLeave={() => setBackgroundColor(defaultBackground)}
        backgroundColor={backgroundColor}
      >
        <Text>{storedValue}</Text>
      </StyledOption>
    </tr>
  )
}

const StyledSelectOpener = styled.div<{width: string}>`
  width: ${props => props.width};
  height: 26px;
  display: flex;
  font-size: 16px;
  text-align: left;
  padding-left: 5px;
  border: 0;
  border-bottom: 2px solid #dddddf;
  justify-content: space-between;
  cursor: pointer;
`

const StyledSelectionTable = styled.table<{width: string}>`
  width: ${props => props.width};
  position: absolute;
  z-index: 2;
  padding-left: 0;
  background-color: white;
  border-spacing: 0;
  border: 1px solid #dddddf;
  border-bottom: 2px solid #dddddf;
  border-top: 0;
  padding-bottom: 2px;
`

const StyledOption = styled.td<{backgroundColor: string}>`
  background-color: ${props => props.backgroundColor};
  font-size: 16px;
  text-align: left;
  padding-bottom: 0;
  padding-left: 5px;
  cursor: pointer;
`
